import React from 'react';

const OverlookIcon = (props) => {
  return (
    <img
      alt="Góra"
      src="/static/images/icons/tourist_attractions/overlook.svg"
      {...props}
    />
  );
};

export default OverlookIcon;
